var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalIconBluehost({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_235_13849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C16 23.1634 23.1634 16 32 16H100C108.837 16 116 23.1634 116 32V100C116 108.837 108.837 116 100 116H32C23.1634 116 16 108.837 16 100V32Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 46H57.166V57.259H46V46Z",
    fill: "#196BDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4026 46H71.5686V57.259H60.4026V46Z",
    fill: "#196BDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8337 46H85.9997V57.259H74.8337V46Z",
    fill: "#196BDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60.5811H57.166V71.8401H46V60.5811Z",
    fill: "#196BDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4026 60.5811H71.5686V71.8401H60.4026V60.5811Z",
    fill: "#196BDE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8337 60.5811H85.9997V71.8401H74.8337V60.5811Z",
    fill: "#196BDE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46 75.1621H57.166V86.4212H46V75.1621Z",
    fill: "#196BDE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4026 75.1621H71.5686V86.4212H60.4026V75.1621Z",
    fill: "#196BDE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8337 75.1621H85.9997V86.4212H74.8337V75.1621Z",
    fill: "#196BDE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_235_13849",
    x: 0,
    y: 0,
    width: 132,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160156 0 0 0 0 0.211953 0 0 0 0 0.3125 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_235_13849"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_235_13849",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIconBluehost);
export default __webpack_public_path__ + "static/media/modal-icon-bluehost.260c333f94541dad370f3faef14354af.svg";
export { ForwardRef as ReactComponent };